
import { Vue, Component, Prop,Watch } from "vue-property-decorator";
import { BaseVue } from "@newview/base-web";
import { comForm } from "@newview/ui";
import echarts from "echarts";
import "echarts-liquidfill";
@Component({
  name: "",
  components: {
    comForm
  },
})
export default class echartClass extends BaseVue {
  @Prop({ default: () => "line" }) type!: any; //图表类型
  @Prop({ default: () => {} }) options!: any; //图表配置项
//#region 接口定义区

//#endregion 接口定义区


//#region 变量定义区
chartContainer = this.NewGuid()
chartObj:any = null
chartOption = {}

defaultConfig = {
  title:{
    show:false
  },
  grid:{},
  legend:{
    show:true,
    left:"center",
    top:"bottom"
  },
  xAxis:{
    type: 'category',
    nameTextStyle:{
      color:"#999999"
    },
    axisLine:{
      lineStyle:{
        color:"#EBEDF0"
      }
    },
    splitLine:{
      lineStyle:{
        type:"dashed",
      }
    },
    axisLabel:{
      color:"#343434"
    },
    axisTick:{
      show:false
    },
    data: []
  },  
  yAxis:{
    type: 'value',
    nameTextStyle:{
      color:"#999999"
    },
    axisLine:{
      show:false
    },
    axisLabel:{
      color:"#343434"
    },
    axisTick:{
      show:false
    },
    splitLine:{
      lineStyle:{
        type:"dashed",
      }
    },
  },
  color:['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de', '#3ba272', '#fc8452', '#9a60b4', '#ea7ccc']
}


chartConfigObj = {
  line:this.merge(this.defaultConfig,{
  }),
  bar:this.merge(this.defaultConfig,{
    xAxis:undefined,
    yAxis:undefined
  }),
  pie:this.merge(this.defaultConfig,{
    xAxis:undefined,
    yAxis:undefined
  }),
}

//#endregion 变量定义区

@Watch("options",{deep:true})
optionsChange(){
  if(this.chartObj){
    this.chartObj.clear()
    this.chartOption = this.merge(this.chartConfigObj[this.type],this.deepCloneObj(this.options))
    this.chartObj.setOption(this.chartOption)
  }else{
    let fun = ()=>{      
      setTimeout(() => {
        if(this.chartObj){
          this.chartObj.clear()
          this.chartOption = this.merge(this.chartConfigObj[this.type],this.deepCloneObj(this.options))
          this.chartObj.setOption(this.chartOption)
        }else{
          fun()
        }        
      }, 100);
    }
    fun()
  }
}

//#region 事件定义区
  mounted() {
    this.chartOption = this.merge(this.chartConfigObj[this.type],this.deepCloneObj(this.options))
    // this.options = this.type && this.chartConfigObj[this.type]?this.merge(this.chartConfigObj[this.type],this.options):this.options
    this.$nextTick(()=>{        
      let dom:any = this.getElementById(this.chartContainer)
      this.chartObj = echarts.init(dom)    
      this.setOption(this.chartOption)         
      this.chartObj.on('click', (params)=> {
        this.$emit("click",params)
      });  
    })
    
        window.addEventListener("resize", () => {
            this.resize()
        })
  }
  setOption(options,state=true){
    this.chartObj.setOption(options,state)        
  }
  resize(){
    this.chartObj.resize()
  }
  dispatchAction(param){
    this.chartObj.dispatchAction(param)
  }
  
//#endregion 事件定义区


//#region 方法定义区

  // 合并对象或数据
  public merge(target, ...arg) {
      return arg.reduce((acc, cur) => {
          return Object.keys(cur).reduce((subAcc, key) => {
              const srcVal = cur[key]
              if (this.isObject(srcVal)) {
                  subAcc[key] = this.merge(subAcc[key] ? subAcc[key] : {}, srcVal)
              } else if (this.isArray(srcVal)) {
                  // series: []，下层数组直接赋值
                  subAcc[key] = srcVal.map((item, idx) => {
                      if (this.isObject(item)) {
                          const curAccVal = subAcc[key] ? subAcc[key] : []
                          return this.merge(curAccVal[idx] ? curAccVal[idx] : {}, item)
                      } else {
                          return item
                      }
                  })
              } else {
                  subAcc[key] = srcVal
              }
              return subAcc
          }, acc)
      }, target)
  }
  public isObject(obj) {
      return Object.prototype.toString.call(obj) === '[object Object]'
  }
  public isArray(arr) {
      return Array.isArray(arr)
  }

  deepCloneObj(obj){
    return $.extend(true,{},obj)
  }
//#endregion 方法定义区
}
